import "./Popup.css";
import { useContext, useEffect } from "react";
import { Button } from "../Buttons/Button/Button";
import AppContext from "../../AppContext";
import { DETAILS_POPUP } from "../../constants/callTrackingConstants";
import PropTypes from 'prop-types';



const Popup = ({
  setIsVisiblePopUp,
  children,

}) => {
  const { selectedProduct, doCallTracking, number } = useContext(AppContext);
  useEffect(() => {
  
  }, []);

  return (
    <div
      className={`container__popup`}
    >
   
      {children}
      <Button
        btnText="Cerrar"
        containerBtnStyles="close__button__modal__container"
        btnStyles="close__button__modal close__button__modal__advance__balance"
        handleOnClick={() => {
          doCallTracking(
            `${DETAILS_POPUP.CLOSE_BUTTON.elementName}`,
            `${DETAILS_POPUP.CLOSE_BUTTON.elementLocation}${selectedProduct?.pkgType}`,
            number
          );
          setIsVisiblePopUp(false);
        }}
      />
    </div>
  );
};

Popup.propTypes = {
  setIsVisiblePopUp: PropTypes.func,
  children: PropTypes.any
};

export default Popup